import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { AI_CONFIG_PHASE_TYPE_ID, promptTextExcerpt } from '@/app/(dashboard)/prompts/constants';
import { FormAutoComplete } from '@/core/ui';
import { PromptsDocument } from '@/graphql/gql/graphql';
import '@/graphql/query/prompt';
import { useQuery } from '@/libs';
import type { AiConfigBaseName, AiConfigPhaseKey, IStationSchema } from './schema';

const PROMPT_FETCH_LIMIT = 200;

export const PromptIdSelect = ({
  baseName,
  phaseKey,
  field = 'promptId',
  label = 'System prompt',
  className = 'rounded col-span-4',
}: {
  baseName: AiConfigBaseName;
  phaseKey: AiConfigPhaseKey;
  field?: 'promptId' | 'userPromptId';
  label?: string;
  className?: string;
}) => {
  const { control } = useFormContext<IStationSchema>();
  const typeId = AI_CONFIG_PHASE_TYPE_ID[phaseKey];

  const { data, loading } = useQuery(PromptsDocument, {
    variables: { typeId, limit: PROMPT_FETCH_LIMIT },
  });

  const options = useMemo(() => {
    return (data?.admin?.prompts ?? [])
      .filter((prompt): prompt is NonNullable<typeof prompt> => prompt != null)
      .map((prompt) => ({
        key: prompt.id,
        label: prompt.name,
        description: prompt.notes ? promptTextExcerpt(prompt.notes, 80) : undefined,
      }));
  }, [data]);

  return (
    <FormAutoComplete<IStationSchema>
      control={control}
      name={`${baseName}.llm.${field}`}
      label={label}
      placeholder='Select prompt'
      options={options}
      isLoading={loading}
      isDisabled={!loading && options.length === 0}
      variant='faded'
      className={className}
    />
  );
};
